import { BridgeInstance } from '../../instance';
import {
  ChainTransferBridgeFeeRes,
  ChainTransferTaxRes,
  ServerChainRes,
} from './types';

const SUB_URL = `/chains`;

export const getChains = () =>
  BridgeInstance.get<ServerChainRes[]>(`${SUB_URL}`).then((res) => res.data);

// NOTE: cryptocurrency에 모든 값이 포함되어 있음. 사용 여부 판단 필요
export const getTokenTax = (chainSymbol: string, tokenSymbol: string) =>
  BridgeInstance.get<ChainTransferTaxRes>(
    `${SUB_URL}/transfers/taxes/${chainSymbol}/${tokenSymbol}`,
  ).then((res) => res.data);

// NOTE: cryptocurrency에 모든 값이 포함되어 있음. 사용 여부 판단 필요
export const getTokenFee = (chainSymbol: string, tokenSymbol: string) =>
  BridgeInstance.get<ChainTransferBridgeFeeRes>(
    `${SUB_URL}/transfers/fees/${chainSymbol}/${tokenSymbol}`,
  ).then((res) => res.data);
